import { View } from 'react-native';
import styled from 'styled-components/native';

export const ScreenHeader = styled(View)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 24px 20px;
`;
